<template>
    <div class="icon-text mb-2">
        <span class="icon has-text-info mr-2">
            <Icon family="fa" name="fa-user" class="is-greyBG-light" />
        </span>
        <span>{{ name }}</span>
    </div>
</template>
<script>
export default {
    name: "participant",
    props: {
        participant: {
            type: Object,
            required: true,
        },
    },
    computed: {
        name() {
            return this.participant.name;
        },
    },
};
</script>